import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Menu from "@material-ui/core/Menu";
import { Menu as MenuIcon } from "@material-ui/icons";

import "./Header.css";
export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerOpen: false,
      communityEl: null,
      facultyEl: null,
      displayRoute: props.displayRoute,
    };
    this.routes = [
      {
        name: "Home",
        link: "/",
      },
      {
        name: "Committee",
        link: "/committee",
      },
      {
        name: "Faculty",
        link: "/faculty",
      },
      {
        name: "Awardees",
        link: "/awardees",
      },
      {
        name: "Scientific Program",
        link: "/scientific-program",
      },
      // {
      //   name: "Accomodation",
      //   link: "/travel-and-accomodation",
      // },
      {
        name: "Near by Places",
        link: "/nearby-places",
      },
      {
        name: "Contact",
        link: "/contact",
      },

      // {
      //   name: "Trip",
      //   link: "/trip",
      // },
      // {
      //   name: "Abstract",
      //   link: "/abstract",
      // },
    ];
    this.eventCommittee = [
      {
        name: "Organizing Committee",
        link: "/organizing-committee",
      },
      {
        name: "Local Organizing Committee ",
        link: "/local-organizing-committee",
      },
    ];
    this.csiCommittee = [
      {
        name: "ABSI ",
        link: "/absi-committee",
      },
      {
        name: "IAES ",
        link: "/iaes-committee",
      },
    ];
  }

  componentDidUpdate(prevProps) {
    if (this.props.history.location.pathname !== prevProps.history.location.pathname) {
      this.setState({ drawerOpen: false });
    }
    if (this.props.match.params.name !== prevProps.match.params.name) {
      this.setState({ communityEl: null, open: false });
    }
  }

  handleOpen = (event, type) => {
    if (type === "community") {
      this.setState({ communityEl: event.currentTarget, open: true });
    } else {
      this.setState({ facultyEl: event.currentTarget, open: true });
    }
  };

  handleClose = () => {
    this.setState({ communityEl: null, facultyEl: null, open: false });
  };

  navigateTo = (route) => {
    if (route === "/contact") {
      const footer = document.getElementById("footer");
      footer.scrollIntoView({ behavior: "smooth" });
    } else {
      this.props.history.push(route);
    }
    this.toggleDrawer(false);
  };

  toggleDrawer = (toggle) => {
    this.setState({ drawerOpen: toggle });
  };

  scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    this.setState({ drawerOpen: false });
  };

  render() {
    return (
      <header className="header">
        <div className="nav-row-1">
          <div className="row-1-left">
            <a href="/breast-course-1603.pdf" target="_blank" rel="noreferrer noopener">
              <Button color="primary" variant="contained">
                View Brochure
              </Button>
            </a>
          </div>
          <div className="nav-logos">
            <div className="nav-logo-images">
              <img src="/hindilogo.png" alt="Sgpgi Logo" />
              <img src="/endo.png" alt="Endo Logo" />
              <img src="/sgpgi-bhp.png" alt="Breast Course 2026" />
              <img src="/iaes-logo.png" alt="IAES-logo" />
            </div>
          </div>
        </div>
        <div className="nav-row-2">
          <div className="nav-wrapper">
            {/* logo image */}
            <div className="logo" onClick={() => this.navigateTo("/")}>
              <img src="/breastcourse.png" alt="logo" />
            </div>
            {/* nav links */}

            <nav className="nav-links">
              {this.routes.map((route, index) => {
                if (route.name === "Committee") {
                  return (
                    <>
                      <Button key={index} className="link-btn" onClick={(e) => this.handleOpen(e, "community")}>
                        Committee
                      </Button>
                      <Menu
                        anchorEl={this.state.communityEl}
                        open={this.state.open && this.state.communityEl !== null}
                        onClose={this.handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center",
                        }}>
                        <div className="committee-dropdown">
                          <div className="committee-header">
                            <h4 className="dropdown-header">Event Committee</h4>
                            <h4 className="dropdown-header">ABSI Office Bearers</h4>
                          </div>
                          <div className="committee-content">
                            <div className="committee-subsection">
                              {this.eventCommittee.map((member, index) => (
                                <Button key={index} className="menu-link-btn" onClick={() => this.navigateTo(`/committee${member.link}`)}>
                                  {member.name}
                                </Button>
                              ))}
                            </div>
                            <div className="committee-divider" />
                            <div className="committee-subsection">
                              {this.csiCommittee.map((member, index) => (
                                <Button
                                  key={index}
                                  className="menu-link-btn"
                                  onClick={() => this.navigateTo(`/office-bearers${member.link}`)}>
                                  {member.name}
                                </Button>
                              ))}
                            </div>
                          </div>
                        </div>
                      </Menu>
                    </>
                  );
                } else {
                  return (
                    <Button key={index} className="link-btn" onClick={() => this.navigateTo(route.link)}>
                      {route.name}
                    </Button>
                  );
                }
              })}
              {/* <Button className="link-btn" onClick={() => window.open("/e-poster-guidelines.pdf", "_blank")}>
                E-Poster Guildelines
              </Button> */}

              <a href="https://www.thelit.app/view/iaes-midcon-breast-course-sgpgi-twozerotwosix/f6836e" target="_blank">
                <Button className="nav-link-btn abstract-btn">Conference Photos</Button>
              </a>
              <Button
                className="nav-link-btn abstract-btn"
                color="secondary"
                variant="outlined"
                onClick={() => window.open("https://certificate.theonsitetech.org/event/SGPGIBREASTCOURSE2026", "_blank")}>
                Download Certificates
              </Button>
            </nav>

            <div className="header-menu-bar">
              <MenuIcon fontSize="large" style={{ fill: "#fff" }} onClick={() => this.toggleDrawer(true)} />
            </div>
            <Drawer anchor="right" open={this.state.drawerOpen} onClose={(e) => this.toggleDrawer(false)}>
              <div className="drawer-wrapper">
                <div className="drawer-content">
                  <img src="/absi-header.png" alt="logo" className="drawer-logo" onClick={() => this.navigateTo("/")} />
                  {this.routes.map((route, index) => {
                    if (route.name === "Committee") {
                      return (
                        <React.Fragment key={index}>
                          <Button key={index} className="link-btn" onClick={(e) => this.handleOpen(e, "community")}>
                            Committee
                          </Button>
                          <Menu
                            anchorEl={this.state.communityEl}
                            open={this.state.open && this.state.communityEl !== null}
                            onClose={this.handleClose}>
                            <div className="committee-content">
                              <div className="committee-subsection">
                                <h4 className="mobile-dropdown-header">Event Committee</h4>
                                {this.eventCommittee.map((member, index) => (
                                  <Button key={index} className="menu-link-btn" onClick={() => this.navigateTo(`/committee${member.link}`)}>
                                    {member.name}
                                  </Button>
                                ))}
                              </div>
                              <div className="committee-subsection">
                                <h4 className="mobile-dropdown-header">ABSI Office Bearers</h4>
                                {this.csiCommittee.map((member, index) => (
                                  <Button
                                    key={index}
                                    className="menu-link-btn"
                                    onClick={() => this.navigateTo(`/office-bearers${member.link}`)}>
                                    {member.name}
                                  </Button>
                                ))}
                              </div>
                            </div>
                          </Menu>
                        </React.Fragment>
                      );
                    }
                    return (
                      <Button
                        key={index}
                        className={`link-btn ${route.name === "Abstract" ? "abstract-btn" : ""}`}
                        onClick={() => this.navigateTo(route.link)}>
                        {route.name}
                      </Button>
                    );
                  })}

                  <a href="https://www.thelit.app/view/iaes-midcon-breast-course-sgpgi-twozerotwosix/f6836e" target="_blank">
                    <Button className="nav-link-btn abstract-btn">Conference Photos</Button>
                  </a>
                  <Button
                    className="nav-link-btn abstract-btn"
                    color="secondary"
                    variant="outlined"
                    onClick={() => window.open("https://certificate.theonsitetech.org/event/SGPGIBREASTCOURSE2026", "_blank")}>
                    Download Certificates
                  </Button>
                </div>
              </div>
            </Drawer>
          </div>
        </div>
      </header>
    );
  }
}
